import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_shipment_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_shipment_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_6 = {
  id: "kt_shipment_create_details",
  class: "collapse show"
}
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "required" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_18 = { class: "required" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "indicator-label" }
const _hoisted_27 = { class: "indicator-progress" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PackagesListing = _resolveComponent("PackagesListing")!
  const _component_PackagesCreating = _resolveComponent("PackagesCreating")!
  const _component_PackagesEditing = _resolveComponent("PackagesEditing")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('update', 'hubs-shipments'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shipmentDetails') + ' (' + _ctx.shipment.tracknumber + ')'), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('backToList')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitUpdate,
              "validation-schema": _ctx.shipmentsSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.translate('shipmentStatuses')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "statusId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.shipment.statusId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shipment.statusId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.translate('selectStatus')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentStatuses, (shipmentStatus) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: shipmentStatus.id,
                              value: shipmentStatus.id
                            }, _toDisplayString(shipmentStatus.internal[1].title), 9, _hoisted_13))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_ErrorMessage, { name: "statusId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate('driver')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "driverId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.shipment.driverId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shipment.driverId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.translate('selectDriver')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drivers, (driver) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: driver.id,
                              value: driver.id
                            }, _toDisplayString(driver.fullName), 9, _hoisted_21))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_ErrorMessage, { name: "driverId" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  (_ctx.can('update', 'hubs-shipments'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "submit",
                        id: "kt_shipment_create_details_submit",
                        ref: "submitButton",
                        disabled: !_ctx.shipment.isEditable,
                        class: "btn btn-primary"
                      }, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_27, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_28
                        ])
                      ], 8, _hoisted_25))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PackagesListing, {
      "created-shipment": _ctx.shipment,
      onListChanged: _ctx.refreshPackages,
      onShowEditPropertyModal: _ctx.showPackagesEditModal
    }, null, 8, ["created-shipment", "onListChanged", "onShowEditPropertyModal"]),
    _createVNode(_component_PackagesCreating, {
      "shipment-id": _ctx.shipment.id,
      onListChanged: _ctx.refreshPackages
    }, null, 8, ["shipment-id", "onListChanged"]),
    _createVNode(_component_PackagesEditing, {
      "edit-data": _ctx.editData,
      slug: _ctx.shipment.statusSlug,
      onListChanged: _ctx.refreshPackages
    }, null, 8, ["edit-data", "slug", "onListChanged"])
  ], 64))
}